import { AsyncPipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, DOCUMENT, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { AuthService, BaseSiteService, CmsService, RoutingService } from '@spartacus/core';
import { StorefrontComponent } from "@spartacus/storefront";
import { UserAccountFacade } from '@spartacus/user/account/root';
import $ from 'jquery';
import { Observable, Subscription, race, timer } from 'rxjs';
import { distinctUntilChanged, filter, map, take } from 'rxjs/operators';
import * as _ from 'underscore';
import { AuthRehydratorService } from './auth-rehydrator.service';
import { CustomAddToCartService } from './custom-add-to-cart/custom-add-to-cart.service';
import { CustomCustomerServiceBrService } from './custom-customer-service-br/custom-customer-service-br.service';
import { TicketDetailsComponent } from './custom-customer-service-br/ticket-details/ticket-details.component';
import { CustomProfileAndPreferencesService } from './custom-profile-and-preferences/custom-profile-and-preferences.service';
import { LoaderService } from './loader-service.service';
import { ConfirmProfilePopupComponent } from './shared/modules/confirm-profile-popup/confirm-profile-popup/confirm-profile-popup.component';
import { EmailPopupComponent } from './shared/modules/email-popup/email-popup/email-popup.component';
import { ExternalsiteAlertComponent } from './shared/modules/externalsite-alert/externalsite-alert/externalsite-alert.component';
import { InfluenzaCartComponent } from './shared/modules/influenza-cart/influenza-cart/influenza-cart.component';
import { LeaveWebsitePopupComponent } from './shared/modules/leave-website-popup/leave-website-popup/leave-website-popup.component';
import { PersonalizationBannerComponent } from './shared/modules/personalization-banner/personalization-banner.component';
import { ReleaseBannerModule } from './shared/modules/release-banner/release-banner.module';
import { LoginEntryService } from './shared/services/login-entry.service';
import { CartEntryService } from './shared/services/cart-entry.service';
import { DataLayerService } from './shared/services/data-layer.service';
import { FeatureFlagService } from './shared/services/feature-flag.service';
import { SharedService } from './shared/services/shared.service';
import { VwoService } from './shared/services/vwo.service';
import { AUTH_KEY, CURR, isPublicOrUnprotectedUrl, REDIRECT_KEY, USER_ID } from './utils/auth-utils';
import { shouldSkipPostLoginRedirect } from './utils/build-login-url';
import { VscaLoginFormComponentService } from './spartacus/features/user/account/components/login-form';

declare global {
  interface Window {
    _vwo?: {
      push: (args: any[]) => void;
    };
    navigateViaAngular?: (url: string) => void;
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [StorefrontComponent, ReleaseBannerModule, AsyncPipe]
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  eventReference: any;
  ticketId: any;
  isUserLoggedIn = false;
  pageName: string;
  pageId: string;
  modalOption: NgbModalOptions = {};
  emailConsent: any;
  userId: any;
  redirection_boolean: any;
  isAsmEnabled: any;
  isLoggedIn: Observable<boolean>;
  emailConsentEnabled: boolean;
  isSSOEnabled: boolean = false;
  modalRef: NgbModalRef;
  popupSubscription: Subscription;
  modalSubscription: Subscription;
  baseSiteId: any;
  allCartItemsSub: Subscription;
  cartItems: any;
  influenzaRedirectionModal: NgbModalRef;
  show: boolean;
  userDetailsData: any;
  b2bUidSelectedLoc: any;
  multiLoc: boolean = false;
  singleLoc: boolean = false;
  companyName: any;
  device: string;
  activeRouteSub: Subscription;
  loaderSub: Subscription;
  authServiceSub: Subscription;
  baseSiteSub: Subscription;
  activatedRouteSub: Subscription;
  userSub: Subscription;
  currentPageSub: Subscription;
  activeSite$: any;
  constructor(
    private readonly authRehydrator: AuthRehydratorService,
    private readonly renderer: Renderer2,
    private readonly pageDate: CmsService,
    private readonly authService: AuthService,
    private readonly sharedService: SharedService,
    private readonly router: RoutingService,
    private readonly route: Router,
    private readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private readonly ref: ChangeDetectorRef,
    private readonly customerService: CustomCustomerServiceBrService,
    private readonly csAgentAuthService: CsAgentAuthService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly baseSite: BaseSiteService,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly add2CartService: CustomAddToCartService,
    private readonly loader: LoaderService,
    private readonly title: Title,
    private readonly _datalayer: DataLayerService,
    private readonly vwoService: VwoService,
    private readonly featureFlagService: FeatureFlagService,
    private readonly loginEntryService: LoginEntryService,
    private readonly cartEntryService: CartEntryService,
    private readonly vscaLoginFormComponentService: VscaLoginFormComponentService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.isLoggedIn = this.authService.isUserLoggedIn();
    window.location.origin.includes('vax') && this.baseSite.setActive('vax');
    window.location.origin.includes('vsh') && this.baseSite.setActive('vsh');

    this.activeRouteSub = this.activatedRoute.queryParams.subscribe((res) => {
      if (Object.keys(res).length > 0) {
        localStorage.setItem('qstring', JSON.stringify(res));
        if (res?.hasOwnProperty('utm_source')) {
          localStorage.setItem('utm_source', JSON.stringify(res?.utm_source));
        }
        if (res?.hasOwnProperty('utm_medium')) {
          localStorage.setItem('utm_medium', JSON.stringify(res?.utm_medium));
        }
        if (res?.hasOwnProperty('utm_campaign')) {
          localStorage.setItem('utm_campaign', JSON.stringify(res?.utm_campaign));
        }
        if (res?.openLogin === 'true') {
          localStorage.setItem('triggerLoginDrawer', 'true');
        }
      }
      if (res.hasOwnProperty('clearAccountCache')) {
        this.pfService.clearCache(this.userId).subscribe((res) => {
          const params = { ...this.activatedRoute.snapshot.queryParams };
          delete params.clearAccountCache;
          this.route.navigate([], { queryParams: params });
        });
      }
    });
  }

  ngOnInit(): void {
    this.vwoService.init();
    this.authRehydrator.run();

    // Preserve query parameters on initial load if they exist in URL but not in route
    // Only do this for guest users - logged-in users will be redirected to account-overview
    const currentUrl = window.location.href;
    const urlWithQuery = currentUrl.split('?');
    if (urlWithQuery.length > 1 && window.location.pathname.includes('/homepage')) {
      // Check if user is logged in before restoring params
      const isLoggedIn = localStorage.getItem(AUTH_KEY)?.includes(`"${USER_ID}":"${CURR}"`);

      if (!isLoggedIn) {
        // Only restore params for guest users
        const urlParams = new URLSearchParams(urlWithQuery[1]);
        const routeParams = this.activatedRoute.snapshot.queryParams;

        // If URL has params but route doesn't, restore them
        if (urlParams.toString() && Object.keys(routeParams).length === 0) {
          const params: any = {};
          urlParams.forEach((value, key) => {
            params[key] = value;
          });

          // Restore query params to the route
          setTimeout(() => {
            this.route.navigate([], {
              relativeTo: this.activatedRoute,
              queryParams: params,
              replaceUrl: true
            });
          }, 100);
        }
      }
    }

    // Open loggin drawer if requested by user when navigating to the page (only on homepage)
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd), take(1))
      .subscribe(() => {
        const triggerLogin = localStorage.getItem('triggerLoginDrawer');
        if (triggerLogin === 'true' && window.location.pathname.includes('/homepage')) {
          this.tryOpenLoginDrawer();
        }
      });

    // 1. Capture intended URL pre-login, and catch every navigation to the
    // legacy cart route (mini-cart, checkout, future-cart, account overview
    // reorder, etc.) to redirect to the Next.js cart when the flag is on.
    // No-op when the flag is off.
    this.route.events
      .pipe(
        filter((event): event is NavigationStart => event instanceof NavigationStart)
      )
      .subscribe((event) => {
        const isLoggedIn = localStorage.getItem(AUTH_KEY)?.includes(`"${USER_ID}":"${CURR}"`);

        if (!isLoggedIn && !isPublicOrUnprotectedUrl(event.url)) {
          localStorage.setItem(REDIRECT_KEY, event.url);
        }

        this.cartEntryService.redirectFromLegacyCartIfNeeded(event.url);
        this.cartEntryService.redirectFromLegacyCheckoutIfNeeded(event.url);
      });

    // 2. After login, redirect to captured URL
    this.isLoggedIn.pipe(take(1)).subscribe((isLoggedIn) => {
      const redirectUrl = localStorage.getItem(REDIRECT_KEY);
      if (isLoggedIn) {
        if (redirectUrl) {
          localStorage.removeItem(REDIRECT_KEY);
          if (!shouldSkipPostLoginRedirect(redirectUrl)) {
            this.route.navigateByUrl(redirectUrl, { replaceUrl: true });
          }
        } else if (window.location.pathname.includes('/homepage')) {
          this.route.navigateByUrl('/my-account/account-overview', { replaceUrl: true });
        }
      }
    });
    this.route.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (window._vwo && typeof window._vwo.push === 'function') {
          window._vwo.push(['trackPageView']);
        }
      });
    window.navigateViaAngular = (url: string) => {
      if (!url || typeof url !== 'string') {
        return;
      }
      this.route.navigateByUrl(url).catch((err) => {
        console.error('Angular navigation failed:', err);
      });
    };
    this.loaderSub = this.loader.loader$.subscribe((res) => {
      const url = window.location.href;
      if (url.includes('vax')) {
        this.vaxInject(url);
      } else {
        this.vshInject(url);
      }
      this.show = res;
      if (
        this.pageId === 'profile' ||
        this.pageId === 'checkoutPage' ||
        this.pageId === 'FluverifypaymentPage' ||
        this.pageId === 'MyAccountOpenInvoicePaymentPage'
      ) {
        this.ref.detectChanges();
      }
    });
    this.addSnippet();
    const userAgent = navigator.userAgent;
    if (/android/i.test(userAgent)) {
      this.device = 'android';
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      this.device = 'iphone';
    } else {
      this.device = 'device';
    }

    this.authServiceSub = this.authService.logoutInProgress$.subscribe(
      (res) => {
        if (res) {
          localStorage.clear();
          this.vscaLoginFormComponentService.showLoginForm.set(false);
          const _win: any = window;
          //for checkout
          if (sessionStorage.getItem('tempoData') != null) {
            sessionStorage.removeItem('tempoData');
          }
          //for make-a-payment
          if (sessionStorage.getItem('tempoDataInv') != null) {
            sessionStorage.removeItem('tempoDataInv');
          }
        }
      }
    );
    this.activeSite$ = this.baseSite.getActive(); //gets the active basesite id
    this.baseSiteSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => {
        this.featureFlagService.initializeWithCurrentUser(res, this.device);
        this.baseSiteId = res;
      });
    this.activatedRouteSub = this.activatedRoute.queryParams.subscribe(
      (res) => {
        if (res.hasOwnProperty('asm')) {
          this.isSSOEnabled = true;
          this.sharedService.setLocalStorage('ssoEnabled', this.isSSOEnabled);
        }
      }
    );
    this.userSub = this.user
      .get()
      .pipe(distinctUntilChanged((prev, curr) => _.isEqual(prev, curr)))
      .subscribe((res) => {
        if (res === undefined) {
          this.isUserLoggedIn = false;
          this.emailConsentEnabled = false;
          //Tools and resources -pre login link removal
          setTimeout(() => {
            $('.tools-landing-left-section .authenticated-display')
              .removeAttr('style')
              .hide();
          }, 50);
        } else {
          const qresult: any = res;
          this.getUserAccountData(qresult?.userName);
          this.emailConsent = qresult?.emailConsent;
          this.userId = qresult?.userName;

          //Added to know if user is approver or delegate in cust hierarchy - order approval case
          const approverOrDelegate = qresult?.approverOrDelegate
            ? qresult?.approverOrDelegate
            : false;
          this.sharedService.setSessionStorage(
            'approverOrDelegate',
            approverOrDelegate
          );
          this.pfService.getUserDataFromDb(null);
          this.pfService.userData.pipe(take(1))
            .subscribe(res => {
              const excludedSites = ['vsh', 'vax'];
              if (res?.res?.showUserProfilePopup && !excludedSites.includes(this.baseSiteId)) { //if yearly check is true
                this.modalService.open(ConfirmProfilePopupComponent, {
                  centered: true,
                  backdrop: 'static',
                  windowClass: `confirmProfileModal ${this.baseSiteId}`,
                });
              }
            });
          //}

          this.activatedRoute.queryParams.subscribe((params) => {
            const paramsforpopover = params;
            this.ticketId = paramsforpopover.ticketId;
            this.redirection_boolean = paramsforpopover.redirect;
            if (this.ticketId != null && this.redirection_boolean === 'true') {
              this.customerService.getTicketDetails(this.ticketId, this.userId);
              this.modalService.open(TicketDetailsComponent, {
                windowClass: 'ticketdetails-viewmodal',
              });
            }
          });
          this.isUserLoggedIn = true;
          //Tools and resources -post login link addition back
          $('.tools-landing-left-section .authenticated-display').show();
        }
      });
    this.route.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        window.scrollTo(0, 0);
      }
    });

    this.currentPageSub = this.pageDate
      .getCurrentPage()
      .subscribe((res: any) => {
        this.pageName = res?.name;
        this.pageId = res?.pageId;
        let pgURL = window.location.href.split('USD');
        const _win: any = window;

        _win.dataLayer?.forEach((obj, i) => {
          if (
            obj.event === 'page_view' ||
            obj.event === 'view_item_list' ||
            obj.event === 'view_cart' ||
            obj.event === 'view_item' ||
            obj.event === 'begin_checkout' ||
            obj.event === 'view_promotion' ||
            obj.event === 'purchase'
          )
            _win.dataLayer?.splice(i, 1);
        });
        _win.dataLayer?.push({
          event: 'page_view',
          page_location: pgURL[1],
        });
        this._datalayer.addtoDataLayer('clearDataLayer', '', '', '');

        //Loading popup jqeury code for CMS editable Tools and resources pages
        if (
          this.pageId === 'vaccinesforchildren' ||
          this.pageId === 'immunizationschedules' ||
          this.pageId === 'toolsandresources'
        ) {
          this.callPopupJquery();
        }
        if (this.pageId === 'toolsandresources') {
          this.modalSubscription = this.pageDate
            .getContentSlot('SanofiModelWindowSlot')
            .subscribe((res) => {
              if (res?.components[0]?.uid) {
                this.popupSubscription = this.pageDate
                  .getComponentData(res.components[0].uid)
                  .subscribe((res: any) => {
                    if (res?.showPopup === 'true') {
                      this.modalService.open(PersonalizationBannerComponent, {
                        centered: true,
                        windowClass: 'personalization-banner',
                      });
                    }
                  });
              }
            });
          this.modalSubscription?.unsubscribe();
          this.popupSubscription?.unsubscribe();
        }
        if (this.pageId === 'fluseasonreservationpage') {
          this.add2CartService.getAllCarts(this.userId);
          this.allCartItemsSub = this.add2CartService.allCartItems$.subscribe(
            (res) => {
              if (res) {
                let parentCart = res?.carts;
                this.cartItems = res?.carts?.find(
                  (item) => item?.childCarts?.length > 0
                );
                if (
                  this.cartItems?.childCarts?.length > 0 &&
                  !this.modalService.hasOpenModals() &&
                  this.pageId === 'fluseasonreservationpage'
                ) {
                  const fromFluJourney = this.activatedRoute.snapshot
                    .queryParams.fromFlu
                    ? true
                    : false;
                  if (fromFluJourney) {
                    parentCart = parentCart[parentCart?.length - 1];
                    const parentCartId = parentCart?.code;
                    this.add2CartService.clearCart(parentCartId, 'flupage');
                  } else {
                    this.influenzaRedirectionModal = this.modalService.open(
                      InfluenzaCartComponent,
                      {
                        centered: true,
                        backdrop: 'static',
                        windowClass: `influenzaCartModal ${this.baseSiteId}`,
                      }
                    );
                    setTimeout(function() {
                      if ($('.influenzaCartModal').hasClass('show')) {
                        $('ngb-modal-backdrop').css({ opacity: 0.9 });
                      }
                    }, 100);
                  }
                }
              }
            }
          );
        }

        this.isLoggedIn.pipe(take(1)).subscribe((res) => {
          this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
            this.isAsmEnabled = res ? res : false;
          });
          if (!this.isAsmEnabled && !(this.pageId === 'customerDetails' || this.pageId === 'userManagement')) {
            sessionStorage.removeItem('filterAttributes');
            sessionStorage.removeItem('b2BUnitNameFilter');
            sessionStorage.removeItem('b2BUnitFilter');
            sessionStorage.removeItem('emailFilter');
            sessionStorage.removeItem('cusNameFilter');
            sessionStorage.removeItem('userNameFilter');
            sessionStorage.removeItem('pageSizeperPage');
          }
          this.isSSOEnabled = this.sharedService.getLocalStorage('ssoEnabled');
          if (res && !this.isAsmEnabled && !this.isSSOEnabled) {

            if (['Homepage', 'Registration Page'].includes(this.pageName)) {

              if (localStorage.getItem('punchout-sid-key') == null) {
                // Preserve query parameters (including UTM parameters) during redirect
                const currentQueryParams = this.activatedRoute.snapshot.queryParams;

                const { code, ...newCurrentQueryParams } = currentQueryParams;

                this.route.navigate(['my-account/account-overview'], {
                  skipLocationChange: false,
                  replaceUrl: true,
                  queryParams: newCurrentQueryParams
                });

              } else {
                race(
                  this.pfService.userAccountDetails.pipe(
                    filter((details: any) => !!details?.res),
                    take(1)
                  ),
                  timer(8000).pipe(map(() => null))
                ).pipe(take(1)).subscribe((details: any) => {
                  const isFormularyCustomer = !!details?.res?.customerSalesAreaData?.formularyCustomer;
                  this.router.goByUrl(isFormularyCustomer ? 'formulary' : 'Product-Catalogue/c/1');
                });
              }
              this.sharedService.miniCartPopup = true;
            } else if (this.pageId === 'LoginPageReference') {
              // Preserve query parameters during redirect
              const currentQueryParams = this.activatedRoute.snapshot.queryParams;

              const { code, ...newCurrentQueryParams } = currentQueryParams;

              this.route.navigate(['my-account/account-overview'], {
                queryParams: newCurrentQueryParams
              });
            }
            else if (this.pageName === 'Account Overview Page') {
              if (localStorage.getItem('punchout-sid-key')) {
                race(
                  this.pfService.userAccountDetails.pipe(
                    filter((details: any) => !!details?.res),
                    take(1)
                  ),
                  timer(8000).pipe(map(() => null))
                ).pipe(take(1)).subscribe((details: any) => {
                  const isFormularyCustomer = !!details?.res?.customerSalesAreaData?.formularyCustomer;
                  this.router.goByUrl(isFormularyCustomer ? 'formulary' : 'Open-Catalogue/c/1?sortCode=productNameasc');
                });
              }
            }
          } else if (this.isAsmEnabled) {
            if (this.pageId === 'MyAccountInvoicePage') {
              sessionStorage.removeItem('filterAttributes');
              sessionStorage.removeItem('b2BUnitNameFilter');
              sessionStorage.removeItem('b2BUnitFilter');
              sessionStorage.removeItem('emailFilter');
              sessionStorage.removeItem('cusNameFilter');
              sessionStorage.removeItem('userNameFilter');
              sessionStorage.removeItem('pageSizeperPage');
            }
          }
          if (!this.sharedService.getLocalStorage('reservePopUpDisabled'))
            this.sharedService.reserveNowPopup = true;
          //If not logged in and clicked on logo, to redirect to homepage
          if (!res && window.location.pathname.includes('/my-account')) {
            this.loginEntryService.redirectGuestMyAccountIfNeeded();
          }
        });
      });

    this.renderer.listen('document', 'click', (event) => {
      if (
        event.target.parentElement?.parentElement?.parentElement?.parentElement?.classList.contains(
          'app-navigation-links'
        )
      ) {
        event.preventDefault();
        event.target.parentElement.parentElement.parentElement.parentElement.classList.contains(
          'external'
        );
        if (
          event.target.parentElement.parentElement.parentElement.parentElement.classList.contains(
            'external'
          )
        ) {
          const modalRef = this.modalService.open(ExternalsiteAlertComponent, {
            windowClass: 'externalsite-modal',
            backdrop: 'static',
            keyboard: false,
          });
          modalRef.componentInstance.eventReference =
            event.target.parentElement.parentElement.href;
        } else {
          window.open(event.target.parentElement.parentElement.href);
        }
      }

      if (
        event.target.classList.contains('app-navigation-links') ||
        event.target.parentElement?.parentElement?.classList.contains(
          'app-navigation-links'
        )
      ) {
        let type;
        if (event.target.nodeName === 'IMG') {
          type = event.target.parentElement.parentElement.type;
          this.eventReference = event.target.parentElement.parentElement.rel;
        } else {
          type = event.target.type;
          this.eventReference = event.target.rel;
        }
        if (type === 'external') {
          const modalRef = this.modalService.open(ExternalsiteAlertComponent, {
            windowClass: 'externalsite-modal',
            backdrop: 'static',
            keyboard: false,
          });
          modalRef.componentInstance.eventReference = this.eventReference;
        } else if (type === 'internal') {
          window.open(this.eventReference);
        }
      }

      $('.SiteLinks').find('a').addClass('login-link');

      if (event.target.classList.contains('close-banner')) {
        const elementArray = document.getElementsByClassName('Section1');
        const displayBanner = document.getElementsByClassName(
          'ContentSlotHeaderBannerOrdersListing'
        );
        const accImpBanner = document.getElementsByClassName(
          'SanofiAccountOverviewBannerSlot'
        );
        const elementArray1 = document.getElementsByClassName(
          'HeroImageShippingBannerSlot'
        );
        for (let item = 0; item < elementArray1.length; item++) {
          elementArray1[item].className += ' bannerHide';
        }
        for (let item = 0; item < elementArray.length; item++) {
          elementArray[item].className += ' bannerHide';
        }
        for (let item = 0; item < displayBanner.length; item++) {
          displayBanner[item].className += ' bannerHide';
        }
        for (let item = 0; item < accImpBanner?.length; item++) {
          accImpBanner[item].className += ' bannerHide';
        }
      }
      const hamburger = document.getElementsByClassName('cx-hamburger');
      const hideSiteContext = document.getElementsByClassName('SiteContext');
      const hideSiteLink = document.getElementsByClassName('SiteLinks');
      const hideSearchBox = document.getElementsByClassName('SearchBox');
      const hideSiteLogo = document.getElementsByClassName('SiteLogo');
      const hideMiniCart = document.getElementsByClassName('MiniCart');
      const hideSiteLogin = document.getElementsByClassName('SiteLogin');
      let expandedOption;
      for (let i = 0; i < hamburger.length; i++) {
        expandedOption = hamburger[i].classList.contains('is-active');
      }
      if (expandedOption) {
        for (let i = 0; i < hideSiteContext.length; i++) {
          hideSiteContext[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSiteLink.length; i++) {
          hideSiteLink[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSearchBox.length; i++) {
          hideSearchBox[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSiteLogo.length; i++) {
          hideSiteLogo[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideMiniCart.length; i++) {
          hideMiniCart[i].classList.add('noDisplay');
        }
        for (let i = 0; i < hideSiteLogin.length; i++) {
          hideSiteLogin[i].classList.add('noDisplay');
        }
      } else {
        for (let i = 0; i < hideSiteContext.length; i++) {
          hideSiteContext[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSiteLink.length; i++) {
          hideSiteLink[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSearchBox.length; i++) {
          hideSearchBox[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSiteLogo.length; i++) {
          hideSiteLogo[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideMiniCart.length; i++) {
          hideMiniCart[i].classList.remove('noDisplay');
        }
        for (let i = 0; i < hideSiteLogin.length; i++) {
          hideSiteLogin[i].classList.remove('noDisplay');
        }
      }
      this.ref.detectChanges();
    });
  }

  vaxInject(url): void {
    setTimeout(() => {
      if (!$('footer').hasClass('footerVax')) {
        $('footer').addClass('footerVax');
      }
      if ($('.footerAbtVaxServe').length < 1) {
        $('cx-footer-navigation ul li:nth-child(2) .wrapper ul:first li:first')
          .html(`<h5 class="footerAbtVaxServe" style="font-size: 16px;color: #fff; font-family: 'LexendDeca-Bold' !important;margin-bottom:3px;">About VaxServe</h5><p style="font-family: 'LexendDeca-Light' !important;font-style: normal;font-weight: 300;font-size: 14px;line-height: 17px;letter-spacing: 0.345234px; margin-bottom: 5px; text-transform: none !important;">VaxServe is your trusted source for customized ordering, business management tools, and training and educational resources. It’s everything your business needs, all in one place. And as a leading distributor of vaccines, VaxServe not only gives you access to many trusted brands, but expert support and personalized service every step of the way.</p> <br/>
                <h5 class="footerAbtVaxServe" style="font-size: 16px;color: #fff; font-family: 'LexendDeca-Bold' !important;margin-bottom:3px;">Prescribing information & tearsheets</h5><p style="font-family: 'LexendDeca-Light' !important;font-style: normal;font-weight: 300;font-size: 14px;line-height: 17px;letter-spacing: 0.345234px; margin-bottom: 5px; text-transform: none !important;">Get fast access to prescribing information, safety data sheets
            and vaccine information.</p> <br/>
            <h5 class="footerAbtVaxServe" style="font-size: 16px;color: #fff; font-family: 'LexendDeca-Bold' !important;margin-bottom:3px;">Billing & coding support</h5><p style="font-family: 'LexendDeca-Light' !important;font-style: normal;font-weight: 300;font-size: 14px;line-height: 17px;letter-spacing: 0.345234px; margin-bottom: 5px; text-transform: none !important;">Streamline reimbursement with coding guides, training materials & personalized support.</p> <br/>
            <h5 class="footerAbtVaxServe" style="font-size: 16px;color: #fff; font-family: 'LexendDeca-Bold' !important;margin-bottom:3px;">Vaccine returns</h5><p style="font-family: 'LexendDeca-Light' !important;font-style: normal;font-weight: 300;font-size: 14px;line-height: 17px;letter-spacing: 0.345234px; margin-bottom: 5px; text-transform: none !important;">Ordered more than you need? Log in to request a return.</p>`);
      }
      const image = new Image();
      image.className = 'vaxfooter-left';
      image.src = 'img/vax-logo-white.png';
      if ($('.vaxfooter-left').length < 1) {
        $('cx-footer-navigation ul:first li:first').prepend(image);
        $('cx-footer-navigation ul:first li:first .wrapper ul:first li:last')
          .eq(0)
          .append('<p class="cpyRight">&copy; </p>');
        if ($('.cpyRight').length <= 1) {
          const newDate = new Date().getFullYear();
          $('.cpyRight').append(newDate + '  VaxServe');
        }
        $(
          'cx-footer-navigation ul:first li:nth-child(2) .wrapper ul:first li:last'
        ).append(
          '<p class="cpyRightText">This site content is intended for US healthcare professionals only.</p>'
        );

        $(
          'cx-footer-navigation ul:first li:nth-child(3) .wrapper ul:first li:last'
        )
          .append('<br/>')
          .after(
            '<a id="ot-sdk-btn" class="ot-sdk-show-settings" style="font-family:LexendDeca-Regular !important; font-weight: 200 !important;font-size: 14px !important;text-decoration: underline !important;cursor: pointer !important;color: #fff !important;text-transform: none !important; background-color: transparent !important; border: none !important; padding:0px !important;">Do Not Sell or Share My Personal Information</a>'
          );
      }
    }, 2000);
  }
  vshInject(url): void {
    setTimeout(() => {
      const image = new Image();
      image.className = 'footer-left';
      image.src = 'img/footerlogo.png';
      if ($('.footer-left').length < 1) {
        $('cx-footer-navigation ul:first li:first').prepend(image);
      }
      const image1 = new Image();
      image1.className = 'footer-right';
      image1.src = 'img/pasteur.png';
      if ($('.footer-right').length < 1) {
        $('cx-footer-navigation ul:first li:nth-child(3) .wrapper').prepend(
          image1
        );
      }
      if ($('.footerAbtVacc').length < 1) {
        $(
          'cx-footer-navigation ul:first li:nth-child(2) .wrapper ul:first li:first span'
        ).html(
          `<h5 class="footerAbtVacc" style="font-size: 16px;color: #fff; font-family: 'LexendDeca-Bold' !important;">About VaccineShop</h5><p style="font-family: 'LexendDeca-Light' !important;font-style: normal;font-weight: 300;font-size: 14px;line-height: 20px;letter-spacing: 0.345234px; margin-bottom: 40px; text-transform: none !important;">VaccineShop is the healthcare professional's trusted source for vaccines, medical supplies, patient resources and office management tools. It's everything your practice needs, all in one place. And because it's powered by Sanofi, a leading vaccine manufacturer for over a century, you'll get expert support and personalized service every step of the way.</p>`
        );

        $('cx-footer-navigation ul:first li:first .wrapper ul:first li:last')
          .eq(0)
          .append('<p class="cpyRight">&copy; </p>');
        if ($('.cpyRight').length <= 1) {
          const newDate = new Date().getFullYear();
          $('.cpyRight').append(newDate + '  VaccineShop');
        }
        $('cx-footer-navigation ul:first li:nth-child(2)').each(function() {
          if ($('.cpyRightText').length <= 1) {
            $(this)
              .find('.wrapper')
              .after(
                '<p class="cpyRightText test">This site content is intended for US healthcare professionals only.</p>'
              );
          }
        });

        $(
          'cx-footer-navigation ul:first li:nth-child(3) .wrapper ul:first li:last'
        )
          .append('<br/>')
          .after(
            '<a id="ot-sdk-btn" class="ot-sdk-show-settings" style="font-family:LexendDeca-Regular !important; font-weight: 200 !important;font-size: 14px !important;text-decoration: underline !important;cursor: pointer !important;color: #fff !important;text-transform: none !important; background-color: transparent !important; border: none !important; padding:0px !important;">Do Not Sell or Share My Personal Information</a>'
          );
      }
    }, 2000);
  }

  ngOnDestroy(): void {
    this.activeRouteSub?.unsubscribe();
    this.loaderSub?.unsubscribe();
    this.authServiceSub?.unsubscribe();
    this.baseSiteSub?.unsubscribe();
    this.activatedRouteSub?.unsubscribe();
    this.userSub?.unsubscribe();
    this.currentPageSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.route.events
      .pipe(
        filter((e) => e instanceof NavigationEnd && !e.url.includes('homepage'))
      )
      .subscribe((res) => {
        setTimeout(() => {
          const title = this.title.getTitle();
          const newTitle =
            (this.baseSiteId === 'vax'
              ? 'VaxServe US Site'
              : 'VaccineShop US Site') + (title ? ' | ' + title : '');
          this.title.setTitle(newTitle);
        }, 3500);
      });

  }
  emailConsentContent() {
    if (!sessionStorage.getItem('emailPopUp')) {
      this.sharedService.getEmailConsent(this.userId);
      this.emailConsentEnabled = true;
      this.sharedService.emailConsent$.subscribe((result) => {
        if (result) {
          if (
            !this.modalService.hasOpenModals() &&
            result.emailConsentEnabled === true
          ) {
            this.modalOption.backdrop = 'static';
            this.modalOption.keyboard = false;
            this.modalOption.windowClass = 'email-popup-modal';
            const modalRef = this.modalService.open(
              EmailPopupComponent,
              this.modalOption
            );
            modalRef.componentInstance.emailConsentObj = result;
            modalRef.componentInstance.userId = this.userId;
            sessionStorage.setItem('emailPopUp', 'true');
            this.sharedService.emailConsent.next(false);
          }
        }
      });
    }
  }

  callPopupJquery() {
    let modalref: NgbModalRef = this.modalRef;
    let modalService: NgbModal = this.modalService;
    let baseSiteId = this.baseSiteId;
    //Kindly do not use same classes for other components.
    $(document).ready(function() {
      //Immunization links click events
      $('.immunization-schedules-left-section a').off('click');
      $('.immunization-schedules-left-section a').on('click', function(event) {
        event.preventDefault();
        const href = $(this).attr('href');
        openPopup(href);
      });

      //Children Vaccines links click events
      $('.children-vaccines-left-section a').off('click');
      $('.children-vaccines-left-section a').on('click', function(event) {
        event.preventDefault();
        const href = $(this).attr('href');
        openPopup(href);
      });

      //Tool and resoruces landing page click events
      $('.tools-landing-aside .usefulLinks a').off('click');
      $('.tools-landing-aside .usefulLinks a').on('click', function(event) {
        event.preventDefault();
        const href = $(this).attr('href');
        openPopup(href);
      });
    });

    function openPopup(link: string) {
      modalref = modalService.open(LeaveWebsitePopupComponent, {
        windowClass: `${baseSiteId}`,
      });
      modalref.componentInstance.popup_title =
        'You are about to leave Sanofi US website';
      modalref.componentInstance.externalUrl = link;
      modalref.componentInstance.popup_content =
        'By clicking on this link, you will be leaving this Sanofi hosted website,and,depending on the link, will be redirected to either another Sanofi website (for example, to view the Sanofi Privacy Policy) or an independent third-party website.<br /><br /> Sanofi has no control over the content or availability of third-party sites or resources that are linked to, and accepts no liability or responsibility for them or for any loss or damage that may arise from your use of them. The existence of a link between this website and any third party site or resource in no way implies that Sanofi in any way approves of the content of these sites or resources, or any use to which such content maybe put. <br /><br /> Please ensure that you read the legal and privacy policy sections of any website to which you link.';
    }
  }

  getUserAccountData(userId): void {
    this.pfService.getUserAccountDataFromDb(userId);
    this.pfService.userAccountData.subscribe((userData) => {
      if (userData?.res && userData?.res?.length !== 0) {
        this.userDetailsData = userData?.res;
        let accntId =
          this.sharedService.getSessionStorage('selectedLocations')?.length === 1
            ? this.sharedService.getSessionStorage('selectedLocations')[0]
              .accountNumber
            : userData?.res?.defaultB2BUnit?.shippingAddresses?.length === 1
              ? userData?.res?.defaultB2BUnit?.shippingAddresses[0].accountNumber
              : userData?.res?.defaultB2BUnit?.uid;
        this.pfService.getUserAccountDetailsDataFromDb(
          userData?.res?.userName,
          accntId
        );
        localStorage.setItem(
          'user_function',
          userData?.res?.defaultB2BUnit?.customerSalesAreaData?.cseg
        );
        localStorage.setItem(
          'user_type',
          this.isAsmEnabled ? 'sales_rep' : 'customer'
        );
        this.sharedService.setLocalStorage('userId', userData?.res?.userName);
        this.sharedService.setLocalStorage(
          'user_login_id',
          userData?.res?.userName
        );
        setTimeout(() => {
          this.getB2BUid();
        }, 1000);
      }
    });
  }

  getB2BUid() {
    if ('selectedLocations' in sessionStorage) {
      let length = JSON.parse(
        sessionStorage.getItem('selectedLocations')
      ).length;
      if (length > 1) {
        this.multiLoc = true;
        this.singleLoc = false;
      } else {
        this.multiLoc = false;
        this.singleLoc = true;
      }
      let arr = [];
      let arr1 = [];
      for (let i = 0; i < length; i++) {
        arr.push(
          JSON.parse(sessionStorage.getItem('selectedLocations'))[i]
            ?.accountNumber
        );
        arr1.push(
          JSON.parse(sessionStorage.getItem('selectedLocations'))[i]
            ?.companyName
        );
        this.b2bUidSelectedLoc = arr;
        this.companyName = arr1;
      }
    } else {
      //default location
      if (JSON.parse(sessionStorage.getItem('defaultLocation')) !== undefined) {
        this.b2bUidSelectedLoc = JSON.parse(
          sessionStorage.getItem('defaultLocation')
        )[0]?.accountNumber;
        this.multiLoc = false;
        this.singleLoc = true;
        this.companyName = JSON.parse(
          sessionStorage.getItem('defaultLocation')
        )[0]?.companyName;
      }
    }
    this.ref.detectChanges();
  }
  addSnippet() {
    this.sharedService.getsnippetAPI();
    this.sharedService.snippetData$.subscribe((result) => {
      if (!_.isEmpty(result)) {
        let snippetCommentStart = this.renderer.createComment(
          'BEGIN NEW QUALTRICS WEBSITE FEEDBACK SNIPPET'
        );
        let snippetCommentEnd = this.renderer.createComment(
          'END WEBSITE FEEDBACK SNIPPET'
        );

        const snippetValue = result.value.replace(/\\n/g, '');
        let script = this.renderer.createElement('script');
        script.type = `text/javascript`;
        script.text = snippetValue;
        this.renderer.appendChild(this.document.head, snippetCommentStart);
        this.renderer.appendChild(this.document.head, script);
        let snippetDiv = this.renderer.createElement('div');
        snippetDiv.id = result.divId;
        let snippetDivComment = this.renderer.createComment(
          'DO NOT REMOVE-CONTENTS PLACED HERE'
        );
        snippetDiv.appendChild(snippetDivComment);
        this.renderer.appendChild(this.document.head, snippetDiv);
        this.renderer.appendChild(this.document.head, snippetCommentEnd);
      }
    });
  }

  private tryOpenLoginDrawer(): void {
    setTimeout(() => {
      localStorage.removeItem('triggerLoginDrawer');
      this.loginEntryService.openLoginFromOpenLoginQueryParam();
    }, 500);
  }
}
